const configuredApiBaseUrl = String(process.env.REACT_APP_API_BASE_URL || "")
  .trim()
  .replace(/\/+$/, "");
const isLocalBrowser = ["localhost", "127.0.0.1"].includes(
  window.location.hostname
);
const runtimeApiBaseUrl = isLocalBrowser
  ? configuredApiBaseUrl || "http://localhost:5003"
  : `${window.location.origin}/api`;

const config = {
  API_BASE_URL: runtimeApiBaseUrl,

  

  PATIENT: {
    LOGIN: "/patient/login",
    REGISTER: "/patient/register",
    PROFILE: "/patient/profile",
    PROFILE_PICTURE: "/patient/profile-picture"
  }

};

export default config;
